import { CommonModule } from '@angular/common';
import { A11yModule } from '@angular/cdk/a11y';
import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { provideTranslocoScope, TranslocoModule } from '@jsverse/transloco';
import { MzicSvgComponent } from '@mzic/mzic-components';
import { CollectionRevisionNavigationIntent } from '../../collection-flow/collection-revision-file-editor';

@Component({
  selector: 'lib-file-selection-discard-dialog',
  imports: [CommonModule, A11yModule, TranslocoModule, MzicSvgComponent],
  providers: [
    provideTranslocoScope({
      scope: 'mzic-collection-flow',
      alias: 'lang',
    }),
  ],
  templateUrl: './file-selection-discard-dialog.component.html',
  styleUrl: './file-selection-discard-dialog.component.scss',
})
export class FileSelectionDiscardDialogComponent implements AfterViewInit {
  @Input({ required: true }) direction!: CollectionRevisionNavigationIntent;
  @Input() fileNames: readonly string[] = [];
  @Input() busy = false;
  @Output() discard = new EventEmitter<void>();
  @Output() keepEditing = new EventEmitter<void>();

  @ViewChild('keepEditingButton', { read: ElementRef })
  private keepEditingButton?: ElementRef<HTMLButtonElement>;

  readonly titleId = 'file-selection-discard-title';
  readonly descriptionId = 'file-selection-discard-description';

  get discardActionKey(): string {
    return this.direction === 'BACK'
      ? 'lang.file_selection_discard_back'
      : this.direction === 'NEXT'
        ? 'lang.file_selection_discard_next'
        : 'lang.file_selection_discard_leave';
  }

  ngAfterViewInit(): void {
    this.keepEditingButton?.nativeElement.focus();
  }

  @HostListener('document:keydown.escape', ['$event'])
  onEscape(event: KeyboardEvent): void {
    if (this.busy) return;
    event.preventDefault();
    this.keepEditing.emit();
  }

  onOverlayClick(event: Event): void {
    if (!this.busy && event.target === event.currentTarget) {
      this.keepEditing.emit();
    }
  }

  onDiscard(): void {
    if (!this.busy) this.discard.emit();
  }
}
